import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TemplateQuestionList, EditQuestion } from '../../../services/AdminService';
import { FaSave, FaArrowLeft } from 'react-icons/fa';
// import "./Template.css";

const EditQuestions = () => {
  const { templateUuid } = useParams();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchQuestions = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await TemplateQuestionList({ template_uuid: templateUuid });
      setQuestions(response.data?.data || []);
    } catch {
      setError('Failed to fetch questions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchQuestions(); }, [templateUuid]);

  const handleChange = (id, value) => {
    setQuestions(questions.map(q =>
      q.id === id ? { ...q, question_text: value } : q
    ));
  };

  const handleSave = async () => {
    setLoading(true);
    setError('');
    try {
      for (const question of questions) {
        if (!question.question_text.trim()) {
          setError(`Question text for "${question.variable_name}" cannot be empty`);
          setLoading(false);
          return;
        }
      }
      await EditQuestion({
        template_uuid: templateUuid,
        questions: questions.map(q => ({
          id: q.id,
          question_text: q.question_text
        }))
      });
      // navigate(`/back-admin/template/${templateUuid}/summary-questions`);
      navigate(`/back-admin/template`);
    } catch {
      setError('Failed to update questions');
    } finally {
      setLoading(false);
    }
  };

  
  const handleBack = () => {
    navigate(`/back-admin/template/${templateUuid}`);
  };

  return (
    <div className="admin-template-container">
      <div className="admin-template-title">
        Edit Questions for Template
      </div>

      {error && <div className="admin-template-error">{error}</div>}

      <div className="admin-template-fields-card">
        <div className="admin-template-fields-header-row">
          <div>Variable Name</div>
          <div>Question Text</div>
        </div>
        {loading ? (
          <div className="admin-template-loading">Loading...</div>
        ) : questions.length === 0 ? (
          <div className="admin-template-empty-message">No variables/questions found for this template.</div>
        ) : (
          questions.map((q, idx) => (
            <div className="admin-template-field-row" key={q.id || idx}>
              <div className="admin-template-input admin-template-input-variable">
                {q.variable_name}
              </div>
              <div className="admin-template-input">
                <input
                  type="text"
                  value={q.question_text}
                  onChange={e => handleChange(q.id, e.target.value)}
                  placeholder="Enter question text..."
                  disabled={loading}
                />
                {!q.question_text.trim() && error.includes(q.variable_name) && (
                  <div className="invalid-feedback">
                    Question text cannot be empty
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      <div className="admin-template-btn-row">
        <button
          className="btn btn-outline-secondary"
          onClick={handleBack}
          disabled={loading}
        >
          <FaArrowLeft style={{ marginRight: 8 }} /> Back
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={loading}
        >
          <FaSave style={{ marginRight: 8 }} /> Save and Next
        </button>
      </div>
    </div>
  );
};

export default EditQuestions;
